import dynamicSize from '@webtrader/core/dynamic-size';

export interface IMobileSizes {
  select: {
    height: number;
  };
  navigation: {
    headerHeight: number;
  };
  form: {
    actions: {
      buttonSpacing: number;
    };
  };
  basePaddingStart: number;
  basePaddingEnd: number;
}

export interface ISizes {
  mobile: IMobileSizes;
}

export const BASE_SIZES: ISizes = {
  mobile: {
    select: {
      height: dynamicSize.convertSize(44)
    },
    navigation: {
      headerHeight: dynamicSize.convertSize(46)
    },
    form: {
      actions: {
        buttonSpacing: dynamicSize.convertSize(10)
      }
    },
    basePaddingStart: dynamicSize.convertSize(16),
    basePaddingEnd: dynamicSize.convertSize(16)
  }
};
